import Request from './authorized-request';
import Axios from 'axios';

let cancelToken = null;

export default class AssistantsApi {
  static async fetch(options) {
    if (cancelToken) {
      cancelToken.cancel();
      cancelToken = null;
    }

    cancelToken = Axios.CancelToken.source();

    return Request.get('/assistants', {
      params: {
        ...options,
      },
      cancelToken: cancelToken.token,
    });
  }

  static async getConfig() {
    return Request.get('/assistants/config');
  }

  static async fetchOne(id) {
    return Request.get(`/assistants/${id}`);
  }

  static async update(data) {
    return Request.put(`/c/assistants/${data.id}`, data);
  }

  static async remove(data) {
    return Request.delete(`/c/assistants/${data.id}`);
  }

  static async create(data) {
    return Request.post(`/c/assistants`, data);
  }
}
